'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = DisplayMode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

function DisplayMode() {
	var _displayForm = document.querySelector('.liste-gen_displayer');
	if (!_displayForm) return;
	var _radioBts = _displayForm.querySelectorAll('label');

	addHandlers();

	function addHandlers() {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = _radioBts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var el = _step.value;

				el.addEventListener('click', clickRadioBt);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator['return']) {
					_iterator['return']();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}

	function clickRadioBt(e) {
		_pubsub2['default'].emit('load:getStatus', function (isLoading) {
			if (isLoading) {
				e.preventDefault();
			} else {
				// timeout pour serialize form OK
				setTimeout(function () {
					_pubsub2['default'].emit('load:more', true);
				}, 200);
			}
		});
	}
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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